'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = DisplayMode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

function DisplayMode() {
	var _displayForm = document.querySelector('.liste-gen_displayer');
	if (!_displayForm) return;
	var _radioBts = _displayForm.querySelectorAll('label');

	addHandlers();

	function addHandlers() {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = _radioBts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var el = _step.value;

				el.addEventListener('click', clickRadioBt);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator['return']) {
					_iterator['return']();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}

	function clickRadioBt(e) {
		_pubsub2['default'].emit('load:getStatus', function (isLoading) {
			if (isLoading) {
				e.preventDefault();
			} else {
				// timeout pour serialize form OK
				setTimeout(function () {
					_pubsub2['default'].emit('load:more', true);
				}, 200);
			}
		});
	}
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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